import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid, Image, Button } from 'semantic-ui-react'
import { NavLink, useHistory } from "react-router-dom";
import moment from "moment";
import renderHTML from 'react-render-html';
import { Config } from '../../common'
import "./Header.scss";
import logo_img from "../../assets/home/atar_logo.png";
import nav_img from "../../assets/home/no-img.png";
import { useSelector, useDispatch } from 'react-redux'
import { StarButton } from '../../components'
import onClickOutside from "react-onclickoutside";
import { logout } from '../../store/AuthRedux'
import { useTranslation } from "react-i18next";
import paymentFailed from "../../assets/notifications/paymentFailed.svg";
import paymentCompleted from "../../assets/notifications/paymentCompleted.svg";
import amazonClaimed from "../../assets/notifications/amazonClaimed.svg";
import contestRes from "../../assets/notifications/contestRes.svg";
import profile from "../../assets/notifications/profile.svg";

function Nav() {

  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const token = useSelector((state) => state.auth.token)
  const userDetails = useSelector((state) => state.user.userDetails)
  const notifications = useSelector((state) => state.user.notifications)
  const [active, setActive] = useState(false)
  const [not, setNot] = useState(false)
  const [language, setLanguage] = useState(false)


  const changeLang = (val) => {
    i18n.changeLanguage(val)
    setLanguage(false)
    // window.location.reload(false);
  }


  Nav.handleClickOutside = () => {
    setLanguage(false);
    setActive(false);
    setNot(false);
  };


  const randerImgs = (type) => {
    if (type === 'profile-update') {
      return <img className="dice_img" src={profile} />
    } else if (type === 'payment-failed') {
      return <img className="dice_img" src={paymentFailed} />
    } else if (type === 'payment-completed') {
      return <img className="dice_img" src={paymentCompleted} />
    } else if (type === 'giftcard') {
      return <img className="dice_img" src={amazonClaimed} />
    } else if (type === 'contest-results') {
      return <img className="dice_img" src={contestRes} />
    } else {
      return <img className="dice_img" src={profile} />
    }
  }

  return (
    <>
      <Grid className="navbar sticky">
        <Grid.Row className="nav_sec">
          <Grid.Column mobile={7} tablet={10} computer={6}>
            <NavLink to=""><img className="logo" src={logo_img} alt="Logo" /></NavLink>
          </Grid.Column>
          <Grid.Column mobile={1} tablet={3} computer={7}>
            <ul className="nav destops">
              <li><NavLink activeClassName="active" className="nav-link" to='/aboutus'>{t('about.about')} {t('about.us')}</NavLink></li>
              <li><NavLink activeClassName="active" className="nav-link " aria-current="page" to="/contest">Contests</NavLink></li>
              <li><Button onClick={() => setLanguage(!language)} >language <i className={"fa fa-angle-" + (language ? 'up' : 'down')} aria-hidden="true"></i> </Button>
                <div className={"language" + (language ? 'active' : 'inactive')}>
                  <div className="language_button" ><Button onClick={() => changeLang('en')}><a className={i18n.language == 'en' ? "active" : ''}>English</a> </Button></div>
                  <div className="button_border"></div>
                  <div className="language_button"><Button onClick={() => changeLang('hi')}><a className={i18n.language == 'hi' ? "active" : ''}>Hindi ( हिंदी )</a> </Button></div>
                </div>
              </li>
            </ul>
          </Grid.Column>

          <Grid.Column className="right_sec" mobile={7} tablet={3} computer={3}>
            {token ?

              <div className="destopMenu">
                <div className="headerMenu" onClick={() => setActive(!active)}>
                  <Image verticalAlign='middle' className="headerLogo" src={userDetails?.profile?.profileURL ? userDetails?.profile?.profileURL : nav_img} size='tiny' circular />
                </div>
                <div className="notification"  >
                  <NavLink to="#"  >

                    <span onClick={() => setNot(!not)}      >
                      <i className="fa fa-bell" aria-hidden="true" style={{ color: (not ? 'yellow' : 'white') }} >

                      </i>
                    </span>
                    <span style={{ display: (not ? 'none' : 'block') }}     >

                      {

                        (notifications?.data) ? <i className="fa fa-circle dot" aria-hidden="true"></i> : null
                      }
                    </span>


                  </NavLink>


                  {/* <i className="fa fa-circle dot" aria-hidden="true"></i> */}

                </div>
              </div> : <div style={{ margin: "-25px -25px 0px" }}><StarButton background={'mainBg'} title={'Login'} onClickAction={() => history.push('/login')} disableStar={true} /></div>}

            {/* ------------------------------  profile dropdown---------------------- */}

            <div className="mobilenav" style={{ display: (active ? 'block' : 'none') }}>
              <ul className="nav" onClick={() => setActive(false)}>
                <li className="nav-item mx-3 mobiles">
                  <NavLink className="nav-link" aria-current="page" to="">
                    <div>
                      <Image verticalAlign='middle' style={{ height: 30, maxWidth: 30 }} src={userDetails?.profile?.profileURL ? userDetails?.profile?.profileURL : nav_img} size='tiny' circular />
                      {' '}
                      <span>{userDetails?.profile?.name}</span></div>
                  </NavLink>
                </li>

                <li className="nav-item mx-3">
                  <NavLink className="nav-link" aria-current="page" to="/profile">
                    Profile Settings
                  </NavLink>
                </li>
                <div className="blue_border "></div>
                <li className="nav-item">
                  <NavLink className="nav-link" aria-current="page" to="/participationhistory">
                    Participation history
                  </NavLink>
                </li>
                <div className="blue_border "></div>
                <li className="nav-item ">
                  <NavLink className="nav-link" aria-current="page" to="/rewards">
                    My rewards
                  </NavLink>
                </li>
                <div className="blue_border "></div>
                <li className="nav-item">
                  <NavLink className="nav-link" aria-current="page" to="/referearn">
                    Refer & Earn
                  </NavLink>
                </li>

                <div className="blue_border"></div>

                <li className="nav-item mx-3">
                  <NavLink onClick={() => { dispatch(logout()); setActive(false) }} className="nav-link" aria-current="page" to="/login">
                    Log out
                  </NavLink>
                </li>

              </ul>
            </div>


            {/* --------------------------------notification dropdown start---------------------------- */}


            <div className="not" style={{ display: (not ? 'block' : 'none') }} >

              {/* <h5>hello world hello world</h5>
            <div className="blue_border "></div>
            <h5>hello world hello world</h5>
            <div className="blue_border "></div>
            <h5>hello world hello world</h5>
            <div className="blue_border "></div>
            <h5>hello world hello world</h5>
            
            <NavLink to="/notifications"  >

               see all notification
            </NavLink> */}


              {notifications && notifications.data ? notifications.data.slice(0, 3).map((item, key) => {
                let newDate = moment.utc() - moment.utc(item?.createdAt)
                return <div key={key}  >

                  <div className='dropdown-wrapper'   >


                    <div className="icons-notify" >

                      {randerImgs(item.type)}
                    </div>


                    <div className="not-dropdown text">
                      {renderHTML(item.text || "<p></p>")}



                    </div>

                    <div className="not-dropdown date">
                      <h6> {Config.parseDurationNotification(newDate)}</h6>

                    </div>

                  </div>

                  <div className="noti_border "></div>

                </div>
              }) : null}
              <div><NavLink to="/notifications" className="allnotifiy" >View all notification</NavLink></div>







            </div>


          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => Nav.handleClickOutside,
};
export default onClickOutside(Nav, clickOutsideConfig);
